module.exports = __webpack_public_path__ + "static/relatics-00263429908ad823a3f639c976082b71.png";